import { memo } from 'react';
import { compose } from '@beef/utils';
import { withDataConverter } from '@beef/react';
import { areNonFunctionFieldsSame } from "../../../../../../../../../utils/utils";
import { getAccountType } from "../../../../../../../../../../utils/analytics";
import { getWindow } from "../../../../../../../../../../utils/window";
import { ymPushParams } from "../../../../../../../../../../utils/ym.alternative";
import { SumInput as SumInputComponent } from "./SumInput";
import { getAnalyticsConverter } from "./analytics";
export var SumInput = compose(withDataConverter(getAnalyticsConverter({
  getAccountType: getAccountType,
  getWindow: getWindow,
  ymPushParams: ymPushParams
})))( /*#__PURE__*/memo(SumInputComponent, areNonFunctionFieldsSame));